import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'ea-gridky-actions',
    templateUrl: './ea-gridky-actions.component.html',
    styleUrls: ['./ea-gridky-actions.component.scss'],
    standalone: false
})
export class EaGridkyActionsComponent implements OnInit {
  @Input() url: any;
  constructor() {}

  ngOnInit() {}

  downloadDocs() {
    for (const key in this.url) {
      if (this.url.hasOwnProperty(key)) {
        const url = this.url[key];
        this.downloadFile(url, key);
      }
    }
  }

  downloadFile(url: string, filename: string) {
    fetch(url)
      .then(response => response.blob())
      .then(blob => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();
        window.URL.revokeObjectURL(link.href);
      });
  }
}
